module.exports = __webpack_public_path__ + "img/poster.9dd936bc.png";